/* eslint-disable */
import Long from "long";
import * as _m0 from "protobufjs/minimal";

export interface UnitInformation {
  /** the amount of units */
  unitCount: number;
  /** the area size of the smallest unit */
  minSquareMeter: number;
  /** the area size of the largest unit */
  maxSquareMeter: number;
  /** the limit of possible person */
  maxPersons: number;
  /** the minimum amount of bedrooms of all units */
  minBedrooms: number;
  /** the maximum amount of bedrooms of all units */
  maxBedrooms: number;
  /** the minimum amount of bathrooms of all units */
  minBathrooms: number;
  /** the maximum amount of bathrooms of all units */
  maxBathrooms: number;
  /** the label of the unit type */
  unitType: string;
}

function createBaseUnitInformation(): UnitInformation {
  return {
    unitCount: 0,
    minSquareMeter: 0,
    maxSquareMeter: 0,
    maxPersons: 0,
    minBedrooms: 0,
    maxBedrooms: 0,
    minBathrooms: 0,
    maxBathrooms: 0,
    unitType: "",
  };
}

export const UnitInformation = {
  encode(
    message: UnitInformation,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.unitCount !== 0) {
      writer.uint32(8).uint32(message.unitCount);
    }
    if (message.minSquareMeter !== 0) {
      writer.uint32(24).uint32(message.minSquareMeter);
    }
    if (message.maxSquareMeter !== 0) {
      writer.uint32(32).uint32(message.maxSquareMeter);
    }
    if (message.maxPersons !== 0) {
      writer.uint32(40).uint32(message.maxPersons);
    }
    if (message.minBedrooms !== 0) {
      writer.uint32(48).uint32(message.minBedrooms);
    }
    if (message.maxBedrooms !== 0) {
      writer.uint32(56).uint32(message.maxBedrooms);
    }
    if (message.minBathrooms !== 0) {
      writer.uint32(64).uint32(message.minBathrooms);
    }
    if (message.maxBathrooms !== 0) {
      writer.uint32(72).uint32(message.maxBathrooms);
    }
    if (message.unitType !== "") {
      writer.uint32(18).string(message.unitType);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UnitInformation {
    const reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUnitInformation();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.unitCount = reader.uint32();
          break;
        case 3:
          message.minSquareMeter = reader.uint32();
          break;
        case 4:
          message.maxSquareMeter = reader.uint32();
          break;
        case 5:
          message.maxPersons = reader.uint32();
          break;
        case 6:
          message.minBedrooms = reader.uint32();
          break;
        case 7:
          message.maxBedrooms = reader.uint32();
          break;
        case 8:
          message.minBathrooms = reader.uint32();
          break;
        case 9:
          message.maxBathrooms = reader.uint32();
          break;
        case 2:
          message.unitType = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },

  fromJSON(object: any): UnitInformation {
    return {
      unitCount: isSet(object.unitCount) ? Number(object.unitCount) : 0,
      minSquareMeter: isSet(object.minSquareMeter)
        ? Number(object.minSquareMeter)
        : 0,
      maxSquareMeter: isSet(object.maxSquareMeter)
        ? Number(object.maxSquareMeter)
        : 0,
      maxPersons: isSet(object.maxPersons) ? Number(object.maxPersons) : 0,
      minBedrooms: isSet(object.minBedrooms) ? Number(object.minBedrooms) : 0,
      maxBedrooms: isSet(object.maxBedrooms) ? Number(object.maxBedrooms) : 0,
      minBathrooms: isSet(object.minBathrooms)
        ? Number(object.minBathrooms)
        : 0,
      maxBathrooms: isSet(object.maxBathrooms)
        ? Number(object.maxBathrooms)
        : 0,
      unitType: isSet(object.unitType) ? String(object.unitType) : "",
    };
  },

  toJSON(message: UnitInformation): unknown {
    const obj: any = {};
    message.unitCount !== undefined &&
      (obj.unitCount = Math.round(message.unitCount));
    message.minSquareMeter !== undefined &&
      (obj.minSquareMeter = Math.round(message.minSquareMeter));
    message.maxSquareMeter !== undefined &&
      (obj.maxSquareMeter = Math.round(message.maxSquareMeter));
    message.maxPersons !== undefined &&
      (obj.maxPersons = Math.round(message.maxPersons));
    message.minBedrooms !== undefined &&
      (obj.minBedrooms = Math.round(message.minBedrooms));
    message.maxBedrooms !== undefined &&
      (obj.maxBedrooms = Math.round(message.maxBedrooms));
    message.minBathrooms !== undefined &&
      (obj.minBathrooms = Math.round(message.minBathrooms));
    message.maxBathrooms !== undefined &&
      (obj.maxBathrooms = Math.round(message.maxBathrooms));
    message.unitType !== undefined && (obj.unitType = message.unitType);
    return obj;
  },

  fromPartial(object: DeepPartial<UnitInformation>): UnitInformation {
    const message = createBaseUnitInformation();
    message.unitCount = object.unitCount ?? 0;
    message.minSquareMeter = object.minSquareMeter ?? 0;
    message.maxSquareMeter = object.maxSquareMeter ?? 0;
    message.maxPersons = object.maxPersons ?? 0;
    message.minBedrooms = object.minBedrooms ?? 0;
    message.maxBedrooms = object.maxBedrooms ?? 0;
    message.minBathrooms = object.minBathrooms ?? 0;
    message.maxBathrooms = object.maxBathrooms ?? 0;
    message.unitType = object.unitType ?? "";
    return message;
  },
};

type Builtin =
  | Date
  | Function
  | Uint8Array
  | string
  | number
  | boolean
  | undefined;

type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
